module.exports = __webpack_public_path__ + "static/img/liyade7.f26ac553.jpg";